import React from "react";
import { useAtom } from "jotai";
import { MenuItem } from "../components/Menu";
import { blocksRefAtom, currentUserAtom } from "../jotai/atoms";
import { useSendAnalyticsEvent } from "../analytics/events";

export default function ExportText() {
  const sendAnalyticsEvent = useSendAnalyticsEvent();
  const [currentUser] = useAtom(currentUserAtom);
  const [blocksRef] = useAtom(blocksRefAtom);

  if (!currentUser) return null;

  const exportText = () => {
    sendAnalyticsEvent({ name: "exportedBlocksAsText" });
    let allText = "";

    for (const b of Object.values(blocksRef.current)) {
      if (b.type === "text") {
        allText += b.value + "\n";
      }
    }

    const a = document.createElement("a");
    const json = allText,
      blob = new Blob([json], { type: "octet/stream" }),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "exportedText.txt";
    a.click();
    window.URL.revokeObjectURL(url);
  };
  return <MenuItem onSelect={exportText}>Export space as text</MenuItem>;
}
